import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withDefaults } from '../../utils/withDefaults';
import { spreadTypography } from '../../utils/typeUtils';
const RootRoot = styled(Box, {
  shouldForwardProp: prop => prop !== 'color' && prop !== 'uppercase'
})(({
  theme,
  color = 'highlight1',
  uppercase
}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  color: theme.palette[color][color === 'grey' ? '800' : '900'],
  padding: theme.spacing(0.5, 1),
  backgroundColor: theme.palette[color][color === 'grey' ? '100' : '50'],
  borderRadius: theme.spacing(1),
  ...spreadTypography(theme.typography['Lato Caption Small Bold']),
  textTransform: uppercase ? 'uppercase' : 'unset',
  height: theme.spacing(2.5)
}));
export const Root = withDefaults(RootRoot, {
  role: 'button'
});